import { IconPencilRevert, IconTrash } from "../../../../../icons";
import IconButton from "../../../../../components/IconButton";
import { convertDate, dateFromInitial, dateToInitial } from "../../../../../libs/dateUtils";
import { deletePointsByDate } from "../../../service";
import useAuthData from "../../../../../hook/useAppData";
import { useState } from "react";
import { ModalMessage } from "../../../../../components/ModalMessage";
import useTimeSheetStore from "../store/useStore";
import { toastError } from "../../../../../components/Toast";
import { Toaster } from "react-hot-toast";
import { validationWorkTime } from "../../../lib";

function TBodyTimeSheet({ listRender }: any) {
  const { setNeedSpinner, getPointsRange, page, selectSize, renderHeaderTable } = useTimeSheetStore();
  const { token } = useAuthData();
  const [getDate, setGetDate] = useState("");
  const [needModalDelete, setNeedModalDelete] = useState({
    status: false,
    id: 0,
  });

  function handleDeleteClick() {
    deletePointsByDate(getDate, token).then((data) => {
      if (!data?.ok) return toastError("Não pode ser deletado!");
      setNeedSpinner(true);
      getPointsRange(dateFromInitial, dateToInitial);
      setTimeout(() => {
        setNeedSpinner(false);
      }, 400);
    });
  }

  function callModal(date: string) {
    setGetDate(date);
    setNeedModalDelete({ status: true, id: 0 });
  }

  function listRenderObserverThePage(indexOfLine: number) {
    const initialListRender = indexOfLine < (page + 1) * selectSize;
    const endListRender = indexOfLine >= page * selectSize;
    return initialListRender && endListRender;
  }

  return (
    <>
      <ModalMessage
        status={needModalDelete.status}
        onClickCancel={setNeedModalDelete}
        onClickConfirm={handleDeleteClick}
        text="Confirma a exclusão?"
      />
      <Toaster />
      {listRender?.map((row: any, index: any) => {
        const { id, date, workedTime, projectsTime } = row;
        const validation = validationWorkTime(workedTime);
        const URL = `/timesheet/form/${date}`;
        const convertedDate = convertDate(date);
        return (
          listRenderObserverThePage(index) && (
            <>
              <tr className="border-b-2 border-background" id={String(id)} key={index}>
                <td>{convertedDate}</td>
                {Array.from({ length: renderHeaderTable() }).map((_, index) => {
                  return (
                    <>
                      <td>{projectsTime[index]?.projectName || ""}</td>
                      <td className="pl-10">{projectsTime[index]?.workedProjectTime || ""}</td>
                    </>
                  );
                })}
                <td>
                  <span className={validation + ' ml-10'}>{workedTime}</span>
                </td>
                <td>
                  <IconButton className="text-primary text-center" icon={IconPencilRevert} text="" url={URL} />
                </td>
                <td>
                  <IconButton className="text-secondary justify-center" icon={IconTrash} text="" onClick={() => callModal(date)} />
                </td>
              </tr>
            </>
          )
        );
      })}
    </>
  );
}

export default TBodyTimeSheet;
